import { render, staticRenderFns } from "./RecordEditDialog.vue?vue&type=template&id=0b2cde74&"
import script from "./RecordEditDialog.vue?vue&type=script&lang=js&"
export * from "./RecordEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports